import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Container,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdLock, MdHome, MdArrowBack } from "react-icons/md";
import { getDefaultRoute } from "../../config/routeConfig";

const UnauthorizedAccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRoles = useSelector((state) => state.user.userInfo.user_roles);

  const handleGoHome = () => {
    const defaultRoute = getDefaultRoute(userRoles);
    navigate(defaultRoute);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <Card
          sx={{
            maxWidth: 600,
            width: "100%",
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={3} alignItems="center">
              {/* Error Icon */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  bgcolor: "warning.light",
                  color: "white",
                  mb: 2,
                }}
              >
                <MdLock size={60} />
              </Box>

              {/* 403 Title */}
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "4rem", md: "6rem" },
                  fontWeight: "bold",
                  color: "primary.main",
                  lineHeight: 1,
                }}
              >
                403
              </Typography>

              {/* Error Message */}
              <Typography
                variant="h4"
                sx={{
                  color: "text.primary",
                  fontWeight: "medium",
                  mb: 1,
                }}
              >
                غير مخول للوصول
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  maxWidth: 400,
                  lineHeight: 1.6,
                }}
              >
                عذراً، لا تمتلك الصلاحية الكافية للوصول إلى هذه الصفحة. يرجى
                التواصل مع المسؤول للحصول على الصلاحيات المطلوبة.
              </Typography>

              {/* Current Route Info (for debugging) */}
              {process.env.NODE_ENV === "development" && (
                <Box
                  sx={{
                    p: 2,
                    bgcolor: "grey.100",
                    borderRadius: 1,
                    maxWidth: 400,
                    width: "100%",
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    المسار الحالي: {location.pathname}
                  </Typography>
                  {userRoles && userRoles.length > 0 && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                    >
                      الأدوار: {userRoles.join(", ")}
                    </Typography>
                  )}
                </Box>
              )}

              {/* Action Buttons */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ mt: 4, width: "100%", maxWidth: 400 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<MdHome />}
                  onClick={handleGoHome}
                  sx={{
                    flex: 1,
                    py: 1.5,
                    fontSize: "1rem",
                  }}
                >
                  الصفحة الرئيسية
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  startIcon={<MdArrowBack />}
                  onClick={handleGoBack}
                  sx={{
                    flex: 1,
                    py: 1.5,
                    fontSize: "1rem",
                  }}
                >
                  العودة للخلف
                </Button>
              </Stack>

              {/* Additional Help Text */}
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  mt: 2,
                }}
              >
                إذا كنت تعتقد أن هذا خطأ، يرجى الاتصال بالدعم الفني
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default UnauthorizedAccess;
